let emojis = ['🍺', '🍻', '🍶', '🍵', '☕️', '🍼', '💻', '👙', '🐶', '🎮', '💪']
export default emojis



// WEBPACK FOOTER //
// ./src/data/emojis.js